<template>
  <v-container>
    <v-expansion-panel>
      <v-expansion-panel-content v-for="(l, idx) in LenderLoanInfo" :key="idx">
        <template slot="header">
          <loan-info :disableFields="disableFields" :loan="l" :idx="idx" v-on:removeLender="removeLender(idx)"></loan-info>
        </template>
        <v-card>
          <v-divider></v-divider>
          <lender-info :disableFields="disableFields" :lender="l"></lender-info>
        </v-card>
      </v-expansion-panel-content>
    </v-expansion-panel>
    <v-layout justify-end row wrap>
      <v-flex xs12>
        <v-btn absolute right color="secondary" @click="LenderLoanInfo.push({})">add lender</v-btn>
      </v-flex>
    </v-layout>
    <br/><br/>
    <v-layout row wrap>
      <v-flex xs6 style="padding-left:32px">
        <v-text-field
          label="Total number of Lenders"
          :value="LenderLoanInfo.length"
          :rules="[rules.NumLoans(LenderLoanInfo)]"
          readonly
        ></v-text-field>
      </v-flex>
      <v-flex xs6></v-flex>
      <v-flex xs6>
        <v-text-field
          label="Total Eligible Debt Seeking Assistance Through WySLRP"
          :value="total"
          prepend-icon="attach_money"
          readonly
        ></v-text-field>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Rules from '../validation/rules'
import LoanInfoVue from './LoanAndLender/LoanInfo.vue';
import LenderInfoVue from './LoanAndLender/LenderInfo.vue';
export default {
  props: {
    LenderLoanInfo: Array,
    disableFields: Boolean
  },
  data(){
    return {
      rules: Rules
    }
  },
  created(){

  },
  methods: {
    removeLender(idx){
      if(this.LenderLoanInfo.length > 1){
        let lender = this.LenderLoanInfo.splice(idx,1)
        if(lender[0].ID && lender[0].ID > 0){
          axios.delete(`LenderAndLoanInfo/${lender[0].ID}`).then(res => {
            console.log(res.data);
          }).catch(err => {
            console.log(err)
          })
        }
      }
    }

  },
  computed: {
    total(){
      let sum = 0
      this.LenderLoanInfo.forEach(l => {
        sum += parseFloat(l.CurrentLoanPAndIBalance)
      })
      return sum
          .toLocaleString('en-US', { style: 'currency', currency: 'USD' })
          .replace('$', '')
    }
  },
  watch: {
    LenderLoanInfo: {
      handler(val){
        this.$emit('input', val)
      },
      deep: true
    },
    total(val){
      this.$emit('updateTotal', val)
    }
  },
  components: {
    'loan-info' : LoanInfoVue,
    'lender-info' : LenderInfoVue
  }
}
</script>

<style>
.v-messages__message {
color: red !important;
}
</style>
